import React from "react";
import chickenFeast from "../assets/promo_chicken_feast.png";
import chickenBurger from "../assets/promo_chicken_burger.png";
import chickenRoll from "../assets/promo_chicken_roll.png";

const PromoBanners = () => {
  const banners = [
    {
      id: 1,
      badge: "ON THIS WEEK",
      titlePart1: "SPICY",
      titlePart2: " FRIED CHICKEN",
      subtitle: "LIMITS TIME OFFER",
      image: chickenFeast,
      themeColor: "#ef4444", // Red
      btnClass: "btn-promo-1",
      floatClass: "animate-float-1",
      imgClass: "scale-[1.15] translate-x-2 translate-y-1"
    },
    {
      id: 2,
      badge: "WELCOME FRESHEAT",
      titlePart1: "TODAY",
      titlePart2: " SPECIAL FOOD",
      subtitle: "LIMITS TIME OFFER",
      image: chickenBurger,
      themeColor: "#f59e0b", // Amber
      btnClass: "btn-promo-2",
      floatClass: "animate-float-2",
      imgClass: "scale-[1.15] translate-y-2"
    },
    {
      id: 3,
      badge: "ON THIS WEEK",
      titlePart1: "SPECIAL",
      titlePart2: " CHICKEN ROLL",
      subtitle: "LIMITS TIME OFFER",
      image: chickenRoll,
      themeColor: "#f97316", // Orange
      btnClass: "btn-promo-3",
      floatClass: "animate-float-3",
      imgClass: "scale-[1.15] translate-x-2 translate-y-1"
    }
  ];

  return (
    <section className="bg-[#fbf9f6] pb-24 pt-4 px-6 relative select-none">
      {/* Dynamic Keyframes and Interactive Styles */}
      <style
        dangerouslySetInnerHTML={{
          __html: `
        @keyframes float-1 {
          0%, 100% { transform: translateY(0) rotate(0deg); }
          50% { transform: translateY(-7px) rotate(1.5deg); }
        }
        @keyframes float-2 {
          0%, 100% { transform: translateY(0) rotate(0deg); }
          50% { transform: translateY(-9px) rotate(-1deg); }
        }
        @keyframes float-3 {
          0%, 100% { transform: translateY(0) rotate(0deg); }
          50% { transform: translateY(-6px) rotate(2deg); }
        }
        @keyframes float-badge {
          0%, 100% { transform: translateY(0) scale(1); }
          50% { transform: translateY(-4px) scale(1.03); }
        }
        @keyframes spin-slow {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        .animate-float-1 {
          animation: float-1 4.5s infinite ease-in-out;
        }
        .animate-float-2 {
          animation: float-2 5.5s infinite ease-in-out;
        }
        .animate-float-3 {
          animation: float-3 5s infinite ease-in-out;
        }
        .animate-float-badge {
          animation: float-badge 3.2s infinite ease-in-out;
        }
        .animate-spin-slow {
          animation: spin-slow 22s infinite linear;
        }
        .btn-promo-1 {
          background-color: #ef4444;
          border-color: #ef4444;
          color: #ffffff;
        }
        .btn-promo-1:hover {
          background-color: #ffffff;
          color: #ef4444;
          border-color: #ffffff;
        }
        .btn-promo-2 {
          background-color: #f59e0b;
          border-color: #f59e0b;
          color: #ffffff;
        }
        .btn-promo-2:hover {
          background-color: #ffffff;
          color: #f59e0b;
          border-color: #ffffff;
        }
        .btn-promo-3 {
          background-color: #f97316;
          border-color: #f97316;
          color: #ffffff;
        }
        .btn-promo-3:hover {
          background-color: #ffffff;
          color: #f97316;
          border-color: #ffffff;
        }
      `,
        }}
      />

      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-8 relative z-10">
        {banners.map((b) => (
          <div
            key={b.id}
            className={`bg-gradient-to-br from-[#18181b] to-[#0b0b0c] rounded-2xl border border-white/[0.04] p-7 md:p-8 flex items-center justify-between relative overflow-hidden h-[260px] group transition-all duration-500 hover:-translate-y-2.5 ${
              b.id === 1
                ? "hover:border-[#ef4444]/35 hover:shadow-[0_20px_40px_rgba(239,68,68,0.14)]"
                : b.id === 2
                ? "hover:border-[#f59e0b]/35 hover:shadow-[0_20px_40px_rgba(245,158,11,0.14)]"
                : "hover:border-[#f97316]/35 hover:shadow-[0_20px_40px_rgba(249,115,22,0.14)]"
            }`}
          >
            {/* Ambient Background Radial Glow */}
            <div
              className="absolute bottom-[-35%] right-[-15%] w-60 h-60 rounded-full blur-[65px] opacity-15 group-hover:opacity-35 transition-opacity duration-700 pointer-events-none"
              style={{
                background: `radial-gradient(circle, ${b.themeColor} 0%, transparent 70%)`
              }}
            />

            {/* Left Content Column */}
            <div className="flex flex-col justify-between h-full z-10 w-[55%]">
              <div>
                {/* Dynamic Pill Badge */}
                <div 
                  className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[9px] font-black tracking-widest uppercase font-mono transition-colors duration-300"
                  style={{
                    color: b.themeColor,
                    borderColor: `${b.themeColor}25`,
                    backgroundColor: `${b.themeColor}09`,
                    borderWidth: '1px'
                  }}
                >
                  <span className="h-1.5 w-1.5 rounded-full animate-pulse" style={{ backgroundColor: b.themeColor }} />
                  {b.badge}
                </div>

                {/* Main Heading with highlighted word */}
                <h3 className="text-xl md:text-[22px] font-black text-white mt-1 leading-tight tracking-tight font-sans uppercase">
                  <span style={{ color: b.themeColor }}>{b.titlePart1}</span>
                  {b.titlePart2}
                </h3>

                {/* Ticker Subtitle */}
                <div className="flex items-center gap-1.5 text-neutral-400 text-[10px] font-bold mt-2.5 tracking-wider font-mono">
                  <svg className="w-3.5 h-3.5 animate-pulse" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" style={{ color: b.themeColor }}>
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="12 6 12 12 16 14" />
                  </svg>
                  <span>{b.subtitle}</span>
                </div>
              </div>

              {/* Call-to-action button */}
              <div className="mt-4">
                <a
                  href="#menu"
                  className={`inline-flex items-center gap-2 px-5 py-3 rounded text-[10px] font-black tracking-widest uppercase transition-all duration-300 border ${b.btnClass}`}
                >
                  <span>ORDER NOW</span>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.5" className="w-3.5 h-3.5 transform group-hover:translate-x-1.5 transition-transform duration-300">
                    <line x1="5" y1="12" x2="19" y2="12" />
                    <polyline points="12 5 19 12 12 19" />
                  </svg>
                </a>
              </div>
            </div>

            {/* Right Visuals Column */}
            <div className="relative w-[45%] h-full flex items-center justify-center select-none">
              
              {/* Concentric Backlighting Rings */}
              <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                <div className="absolute w-36 h-36 border border-white/[0.02] rounded-full group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute w-28 h-28 border border-dashed border-white/[0.05] rounded-full animate-spin-slow" />
                <div 
                  className="absolute w-16 h-16 rounded-full blur-[20px] opacity-25 group-hover:opacity-45 transition-opacity duration-700"
                  style={{ backgroundColor: b.themeColor }}
                />
              </div>

              {/* Product Image */}
              <img
                src={b.image}
                alt={b.titlePart1 + b.titlePart2}
                className={`w-full h-full object-contain drop-shadow-[0_15px_22px_rgba(0,0,0,0.65)] select-none transition-all duration-700 group-hover:scale-[1.22] group-hover:rotate-2 ${b.floatClass} ${b.imgClass}`}
              />

              {/* Floating Sticker Badge */}
              <div className="absolute top-0 -right-2 pointer-events-none select-none z-20 animate-float-badge">
                <div className="relative w-14 h-14 rounded-full bg-gradient-to-tr from-[#f5a623] to-[#f8e71c] border border-white/30 shadow-lg flex flex-col items-center justify-center text-center">
                  <div className="absolute inset-1 rounded-full border border-dashed border-black/10 animate-spin-slow" />
                  <span className="text-[10px] font-black text-neutral-900 leading-none">50%</span>
                  <span className="text-[8px] font-black text-neutral-900 leading-none uppercase mt-0.5">OFF</span>
                </div>
              </div>
            </div>

            {/* Bottom Color Accent Line */}
            <div 
              className="absolute bottom-0 left-0 right-0 h-1 transition-all duration-500"
              style={{ backgroundColor: b.themeColor }}
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default PromoBanners;
